module.exports = __webpack_public_path__ + "static/media/003yhkgl.62c4b100.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/003yhkgl.jpg
// module id = 627
// module chunks = 0 1